function getModuleSegments(path) {
  return path.split('/').filter(Boolean).slice(0, 2).join('/');
}

function isSameModule(pathA, pathB) {
  return getModuleSegments(pathA) === getModuleSegments(pathB);
}

function save(key, inputs, inputs2) {
  try {
    sessionStorage.setItem(key, JSON.stringify({
      inputs,
      inputs2,
      savedPath: window.location.pathname,
    }));
  } catch(e) {}
}

function restore(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch(e) { return null; }
}

function clearIfModuleChanged(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return;
    const data = JSON.parse(raw);
    if (data.savedPath && !isSameModule(data.savedPath, window.location.pathname)) {
      sessionStorage.removeItem(key);
    }
  } catch(e) {}
}

function clear(key) {
  try { sessionStorage.removeItem(key); } catch(e) {}
}

const filterStorage = { save, restore, clearIfModuleChanged, clear };
export default filterStorage;
